module.exports = __webpack_public_path__ + "img/snapsheet-logo.4c5a5f18.png";